import React, { forwardRef } from 'react';

import * as Styled from './popup-menu.style';

export type PopupMenuListProps = {
  hasBottomBorder?: boolean;
  isScrollable?: boolean;
  children: React.ReactNode;
  id?: string;
  role?: React.AriaRole;
  'aria-multiselectable'?: boolean;
};

export const PopupMenuList = forwardRef<HTMLUListElement, PopupMenuListProps>(
  (
    {
      hasBottomBorder,
      isScrollable,
      children,
      id,
      role,
      'aria-multiselectable': ariaMultiselectable,
    },
    ref,
  ) => (
    <Styled.List
      ref={ref}
      id={id}
      role={role}
      aria-multiselectable={ariaMultiselectable}
      $hasBottomBorder={!!hasBottomBorder}
      $isScrollable={!!isScrollable}
    >
      {children}
    </Styled.List>
  ),
);
